import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EligibilityLogsComponent } from './eligibility-logs.component';

const routes: Routes = [
  {
    path: '',
    component: EligibilityLogsComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EligibilityLogsRoutingModule { }
